import { render, staticRenderFns } from "./archives.vue?vue&type=template&id=8e5a1f60&scoped=true&"
import script from "./archives.vue?vue&type=script&lang=js&"
export * from "./archives.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e5a1f60",
  null
  
)

export default component.exports